import React from "react";
import VesselOnboardUsage from "../../../../../components/app/vessel/onboard/usage/Usage";

type ScreenVesselOnboardUsageType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;

const ScreenVesselOnboardUsage: React.FC<
	ScreenVesselOnboardUsageType
> = (props: ScreenVesselOnboardUsageType) => {
	return <VesselOnboardUsage vesselId={props.match.params.vesselId} />;
};

export default ScreenVesselOnboardUsage;
